module.exports = __webpack_public_path__ + "static/internazionale200-dc29873b9cea42f85b7b718eeb2c5877.png";